import { render, staticRenderFns } from "./TabulatorTable.vue?vue&type=template&id=4c1fa454&"
import script from "./TabulatorTable.vue?vue&type=script&lang=js&"
export * from "./TabulatorTable.vue?vue&type=script&lang=js&"
import style0 from "./TabulatorTable.vue?vue&type=style&index=0&id=4c1fa454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports